import type { Key } from './i18n'

/**
 * Server refusals an HONEST person can reach, in words that say what to do.
 * (071/072 — the rest of their codes are only reachable by a forged request,
 * and the generic message is right for those.) The store's `failed` shows
 * these; each word fits EVERY screen the code can come from (fresh review M5:
 * a reused ref is a receipt too, a service meets an import too).
 */
const SERVER_REFUSALS: [string, Key][] = [
  ['RETURN_EXCEEDS_SALE', 'store.refusal.returnExceeds'],
  ['SHIFT_ALREADY_CLOSED', 'store.refusal.shiftClosed'],
  ['RETURN_ORIGINAL_NOT_FOUND', 'store.refusal.returnOriginal'],
  ['ORG_INACTIVE', 'store.refusal.orgInactive'],
  // 098 — support may fix the shop's setup, never its money
  ['SUPPORT_CANNOT', 'store.refusal.support'],
  // 083 — a QR sale is bound to its payment
  ['QR_NOT_PAID', 'store.refusal.qrNotPaid'],
  ['QR_AMOUNT_MISMATCH', 'store.refusal.qrAmount'],
  ['QR_METHOD_MISMATCH', 'store.refusal.qrMethod'],
  // 169 — a service is never stock
  ['SERVICE_NO_STOCK', 'store.refusal.serviceNoStock'],
  // 170 / 171 — a return to a supplier and a receipt that names its money
  ['STOCK_INSUFFICIENT', 'sup.ret.errStock'],
  ['RETURN_EXCEEDS_PURCHASE', 'sup.ret.errRoom'],
  ['CLIENT_REF_REUSED', 'store.refusal.refReused'],
  ['MOVEMENT_LINKED', 'sup.ret.movementLinked'],
  ['PAID_SOURCE_REQUIRED', 'sup.src.err'],
  ['SHIFT_REQUIRED', 'store.shiftRequired'],
  // 186 — a batch changed under the owner's list
  ['LOT_SHORT', 'store.refusal.lotShort'],
  ['LOT_DATE_REQUIRED', 'store.refusal.lotDate'],
  // 191 (1.65) — a supplier order: received or closed on another device, another branch's, a need already ordered
  ['ORDER_NOT_OPEN', 'sorder.err.done'],
  ['ORDER_BRANCH_MISMATCH', 'sorder.err.branch'],
  ['NEED_TAKEN', 'sorder.err.needTaken'],
  ['ORDER_EMPTY', 'sorder.err.empty'],
  // 196 (1.68) — the table's service product, met outside a table bill (an exchange) or by a delete
  ['SERVICE_CHARGE_NOT_HERE', 'tables.err.SERVICE_CHARGE_NOT_HERE'],
  ['SERVICE_PRODUCT_LOCKED', 'tables.err.SERVICE_PRODUCT_LOCKED'],
]

/** The words for a refusal the server raised, or undefined for the generic message. */
export function serverRefusalKey(message: string | null | undefined): Key | undefined {
  if (!message) return undefined
  return SERVER_REFUSALS.find(([code]) => message.includes(code))?.[1]
}
